// import React, { useEffect, useState } from "react";
// import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
// import CircularMeter from "./CircularMeter";
// import "./rentincome.css";
// import APICall from "../../Utility/APICall";
// import { useAuth } from "../../Utility/AuthProvider";
// import { paths } from "../../Utility/Constants";

// export function RentCards({ label, value, color }) {
//   return (
//     <div className="flex flex-col items-center bg-white p-10 cursor-pointer rounded-md shadow-md hover:opacity-75">
//       <p className="text-black font-bold text-md">{label}</p>
//       <p className={`text-lg font-semibold ${color}`}>{value}</p>
//     </div>
//   );
// }

// export default function RentIncome() {
//   const { jwt } = useAuth();
//   const [data, setData] = useState([]);
//   const [chartCounter, setChartCounter] = useState(0);
//   const [previousMonthData, setPreviousMonthData] = useState(null);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const overviewResponse = await APICall(
//           "GET",
//           paths.rent.overview,
//           undefined,
//           undefined,
//           jwt
//         );

//         if (
//           !overviewResponse.response ||
//           !overviewResponse.response.rent_overview
//         ) {
//           throw new Error("Invalid response structure for rent overview"); // Handle unexpected response format
//         }
//         const overviewData = overviewResponse.response.rent_overview;
//         setData(overviewData);
//         console.log("Overview Data:", overviewData);

//         // const previousMonthResponse = await APICall(
//         //   "GET",
//         //   paths.rent.previousMonthOverview,
//         //   undefined,
//         //   undefined,
//         //   jwt
//         // );

//         // if (
//         //   !previousMonthResponse.response ||
//         //   !previousMonthResponse.response.rent_overview
//         // ) {
//         //   throw new Error(
//         //     "Invalid response structure for previous month rent overview"
//         //   ); // Handle unexpected response format
//         // }

//         // const previousMonthData = previousMonthResponse.response.rent_overview;
//         // setPreviousMonthData(previousMonthData);
//         // console.log("Previous Month API Response:", previousMonthResponse);
//       } catch (error) {
//         console.error(`Error fetching rent data:`, error); // Generic error message

//         if (
//           error.message &&
//           error.message.includes("Invalid response structure")
//         ) {
//           console.error("API Response Structure Error:", error.message); // More specific message for structure errors
//         } else if (error.response) {
//           console.error("API Error Details:", error.response.data);
//           console.error("API Error Status:", error.response.status);
//           console.error("API Error Headers:", error.response.headers);
//         } else if (error.request) {
//           console.error("Request Error:", error.request);
//         } else {
//           console.error("General Error:", error.message);
//         }
//       }
//     };

//     fetchData();
//   }, []);

//   function handleOnPressNext() {
//     if (chartCounter === data.length - 1) return;
//     setChartCounter(chartCounter + 1);
//   }

//   function handleOnPressPrev() {
//     if (chartCounter === 0) return;
//     setChartCounter(chartCounter - 1);
//   }

//   function calculatePercentageChange(currentRent, previousRent) {
//     if (previousRent === 0) return "--";
//     const percentageChange =
//       ((currentRent - previousRent) / previousRent) * 100;
//     return percentageChange.toFixed(2) + "%";
//   }

//   return (
//     <div className="border p-8 flex justify-center border-gray-300 shadow-lg rounded-lg">
//       {data && data[chartCounter] && (
//         <>
//           <div className="flex flex-col justify-between">
//             <div className="flex flex-col">
//               <div className="flex justify-between">
//                 <button
//                   style={{ color: chartCounter === 0 ? "grey" : "blue" }}
//                   onClick={handleOnPressPrev}
//                 >
//                   Prev
//                 </button>
//                 <section className="flex flex-col gap-2 items-center">
//                   <p style={{ fontSize: "16px", fontWeight: "bold" }}>
//                     Monthly Rent {data[chartCounter].short_title}
//                   </p>
//                   {/* <h1 className="text-lg">
//                     <p>₹{data[chartCounter].total_rent}</p>
//                   </h1> */}
//                 </section>

//                 <button
//                   style={{
//                     color: chartCounter === data.length - 1 ? "grey" : "blue",
//                   }}
//                   onClick={handleOnPressNext}
//                 >
//                   Next
//                 </button>
//               </div>

//               {/* <CircularMeter progress={10} leftProgress={90} /> */}
//             </div>

//             {/* <div className="calculator flex items-center">
//               <ArrowOutwardIcon sx={{ color: "green" }} />
//               <p style={{ color: "green" }}>
//                 {calculatePercentageChange(
//                   data[chartCounter].total_rent,
//                   previousMonthData && previousMonthData.total_rent
//                 )}
//               </p>
//               <p>
//                 vs {previousMonthData && previousMonthData.total_rent} prev
//                 month
//               </p>
//             </div> */}
//             <div
//               style={{
//                 // height: 45,
//                 // width: 423,
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 gap: 40,
//                 marginTop: 20,
//               }}
//             >
//               <RentCards
//                 label="Recieved"
//                 value={data[chartCounter].received_rent}
//                 color="text-green-500"
//               />
//               {/* <div>
//                 <p>Received</p>₹{data[chartCounter].received_rent}
//               </div> */}
//               {/* <div>
//                 <p>Due</p>₹
//                 {data[chartCounter].total_rent -
//                   data[chartCounter].received_rent}
//               </div> */}
//               <RentCards
//                 label="Due"
//                 value={
//                   data[chartCounter].total_rent -
//                   data[chartCounter].received_rent
//                 }
//                 color="text-green-500"
//               />
//               {/* <div>
//                 <p>Units Paid</p>
//                 {data[chartCounter].tenants_paid}
//               </div> */}
//               <RentCards
//                 label="Units Paid"
//                 value={data[chartCounter].tenants_paid}
//                 color="text-green-500"
//               />
//               {/* <div>
//                 <p>Units Due</p>
//                 {data[chartCounter].total_tenants -
//                   data[chartCounter].tenants_paid}
//               </div> */}
//               <RentCards
//                 label="Units Due"
//                 value={
//                   data[chartCounter].total_tenants -
//                   data[chartCounter].tenants_paid
//                 }
//                 color="text-green-500"
//               />
//               <RentCards
//                 label="Total"
//                 value={data[chartCounter].total_rent}
//                 color="text-green-500"
//               />
//             </div>
//           </div>
//         </>
//       )}
//     </div>
//   );
// }

// import React, { useEffect, useState } from "react";
// // Removed ArrowOutwardIcon, CircularMeter, rentincome.css if not strictly needed for this layout
// import APICall from "../../Utility/APICall";
// import { useAuth } from "../../Utility/AuthProvider";
// import { paths } from "../../Utility/Constants";
// import Lottie from "lottie-react";
// import loaderAnimation from "../../assets/animations/loader.json";
// import { useSettings } from "../../Contexts/SettingsContext";
// import { AppSettings } from "../../Contexts/SettingsContext";

// // Simplified RentCard component using Tailwind
// export function RentCards({ label, value, color = "text-green-600" }) {
//   // Default color
//   return (
//     // Added flex-1 to make cards distribute space, min-w-0 for flex basis issues
//     <div className="flex-1 min-w-0 flex flex-col items-center bg-gray-50 p-3 md:p-4 cursor-pointer rounded-md shadow-sm border border-gray-200 hover:shadow-md transition-shadow">
//       <p className="text-gray-600 font-medium text-xs md:text-sm mb-1 text-center">
//         {label}
//       </p>
//       {/* Ensure color is applied */}
//       <p className={`text-base md:text-lg font-semibold ${color}`}>
//         {
//           // Basic currency formatting (consider Intl.NumberFormat for better formatting)
//           typeof value === "number" ? value.toLocaleString("en-IN") : value
//         }
//       </p>
//     </div>
//   );
// }

// export default function RentIncome() {
//   const { jwt } = useAuth();
//   const [data, setData] = useState([]);
//   const [chartCounter, setChartCounter] = useState(0);
//   const [isLoading, setIsLoading] = useState(true);
//   const settings = useSettings();

//   // Helper function to get settings value with fallback
//   const getSettingsValue = (property) => {
//     return settings?.[property] === undefined
//       ? AppSettings.getDefaultValue(property)
//       : settings[property];
//   };

//   // --- Fetching Logic (Keep as is) ---
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const params = {};
//         const showFutureReports = getSettingsValue(
//           AppSettings.SHOW_FUTURE_REPORTS
//         );
//         params.show_future_rent = showFutureReports ? "true" : "false";

//         const sortByLatest = getSettingsValue(
//           AppSettings.SORT_REPORTS_BY_LATEST_FIRST
//         );
//         params.reverse_order = sortByLatest ? "true" : "false";

//         const language = getSettingsValue(AppSettings.LANGUAGE);
//         if (language && language !== "english") {
//           params.language = language;
//         }

//         console.log("Fetching rent overview with params:", params);

//         const overviewResponse = await APICall(
//           "GET",
//           paths.rent.overview,
//           undefined, // body (not needed for GET)
//           params, // query parameters
//           jwt
//         );

//         console.log("RESPONSE for Rent Overview Call:", overviewResponse);
//         if (
//           !overviewResponse.response ||
//           !overviewResponse.response.rent_overview
//         ) {
//           throw new Error("Invalid response structure for rent overview");
//         }
//         const overviewData = overviewResponse.response.rent_overview;
//         setData(overviewData);
//         console.log("Overview Data:", overviewData);
//       } catch (error) {
//         console.error(`Error fetching rent data:`, error);
//         // Keep detailed error logging
//       }
//     };
//     fetchData();
//   }, [jwt]); // Correct dependency

//   function handleOnPressNext() {
//     if (chartCounter < data.length - 1) {
//       // Corrected condition
//       setChartCounter(chartCounter + 1);
//     }
//   }

//   function handleOnPressPrev() {
//     if (chartCounter > 0) {
//       // Corrected condition
//       setChartCounter(chartCounter - 1);
//     }
//   }

//   // Removed calculatePercentageChange if not displayed

//   const currentMonthData = data && data[chartCounter]; // Get current data safely

//   return (
//     // Removed outer border/shadow as parent Dashboard section provides it
//     <div className="flex flex-col items-center w-full">
//       {currentMonthData ? (
//         <>
//           {/* Top Row: Prev/Next Buttons and Title */}
//           <div className="flex justify-between items-center w-full mb-4 px-2">
//             <button
//               className={`text-sm font-medium ${chartCounter === data.length - 1 ? "text-gray-400 cursor-not-allowed" : "text-blue-600 hover:text-blue-800"}`}
//               onClick={handleOnPressNext}
//               disabled={chartCounter === data.length - 1}
//             >
//               Prev
//             </button>
//             <p className="text-base md:text-lg font-semibold text-gray-700 text-center">
//               Monthly Rent {currentMonthData.short_title}
//             </p>
//             <button
//               className={`text-sm font-medium ${chartCounter === 0 ? "text-gray-400 cursor-not-allowed" : "text-blue-600 hover:text-blue-800"}`}
//               onClick={handleOnPressPrev}
//               disabled={chartCounter === 0}
//             >
//               Next
//             </button>
//           </div>

//           {/* Bottom Row: Rent Cards */}
//           {/* Using Flexbox for the cards layout, allows wrapping on smaller screens */}
//           <div className="flex flex-wrap justify-center gap-3 md:gap-4 w-full">
//             <RentCards
//               label="Received" // Corrected spelling
//               value={currentMonthData.received_rent}
//               color="text-green-600" // Specific color
//             />
//             <RentCards
//               label="Due"
//               value={
//                 currentMonthData.total_rent - currentMonthData.received_rent
//               }
//               color="text-red-600" // Due amount usually red
//             />
//             <RentCards
//               label="Units Paid"
//               value={currentMonthData.tenants_paid}
//               color="text-blue-600" // Or another color
//             />
//             <RentCards
//               label="Units Due"
//               value={
//                 currentMonthData.total_tenants - currentMonthData.tenants_paid
//               }
//               color="text-orange-600" // Or another color
//             />
//             <RentCards
//               label="Total"
//               value={currentMonthData.total_rent}
//               color="text-gray-800" // Total can be neutral
//             />
//           </div>
//           {/* Removed calculator section */}
//         </>
//       ) : (
//         // Show loading or no data message
//         // <div className="text-gray-500 py-8">Loading rent data...</div>
//         <Lottie
//           animationData={loaderAnimation}
//           loop={true}
//           className="w-20 h-20"
//         />
//       )}
//     </div>
//   );
// }

import React, { useEffect, useState } from "react";
import Lottie from "lottie-react";
import loaderAnimation from "../../assets/animations/loader.json";

// 🔥 IMPORT REPORTS CONTEXT instead of making API calls
import {
  useReportsData,
  useUpdateReportsData,
  Loading,
} from "../../Contexts/ReportsContext";

// Simplified RentCard component using Tailwind (unchanged)
export function RentCards({ label, value, color = "text-green-600" }) {
  return (
    <div className="flex-1 min-w-0 flex flex-col items-center bg-gray-50 p-3 md:p-4 cursor-pointer rounded-md shadow-sm border border-gray-200 hover:shadow-md transition-shadow">
      <p className="text-gray-600 font-medium text-xs md:text-sm mb-1 text-center">
        {label}
      </p>
      <p className={`text-base md:text-lg font-semibold ${color}`}>
        {typeof value === "number" ? value.toLocaleString("en-IN") : value}
      </p>
    </div>
  );
}

export default function RentIncome() {
  // 🔥 USE REPORTS CONTEXT instead of local state and API calls
  const reportsData = useReportsData();
  const updateReportsData = useUpdateReportsData();

  // 🔥 USE CONTEXT DATA instead of local state
  const data = reportsData.rentPieChartData || [];
  const isLoading = reportsData.isLoading;
  const showNoAgreement = reportsData.showNoAgreement;

  const [chartCounter, setChartCounter] = useState(0);

  // 🔥 SIMPLIFIED useEffect - Just ensure data is loaded
  useEffect(() => {
    // Only fetch if no data exists and not currently loading
    if (data.length === 0 && !isLoading && !showNoAgreement) {
      console.log("🔄 RentIncome: Triggering data fetch...");
      updateReportsData(Loading.AUTO_REFRESHING);
    }
  }, [data.length, isLoading, showNoAgreement, updateReportsData]);

  // 🔥 RESET chartCounter when data changes
  useEffect(() => {
    if (data.length > 0 && chartCounter >= data.length) {
      setChartCounter(0);
    }
  }, [data.length, chartCounter]);

  // Navigation functions (unchanged)
  function handleOnPressNext() {
    if (chartCounter < data.length - 1) {
      setChartCounter(chartCounter + 1);
    }
  }

  function handleOnPressPrev() {
    if (chartCounter > 0) {
      setChartCounter(chartCounter - 1);
    }
  }

  // 🔥 ENHANCED: Handle different states from context
  const getCurrentMonthData = () => {
    if (showNoAgreement) {
      return null;
    }

    if (data.length === 0) {
      return null;
    }

    return data[chartCounter];
  };

  const currentMonthData = getCurrentMonthData();

  // 🔥 IMPROVED: Better loading and empty states
  if (showNoAgreement) {
    return (
      <div className="flex flex-col items-center justify-center w-full py-8">
        <div className="text-gray-400 mb-2">
          <svg
            className="w-12 h-12"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
          </svg>
        </div>
        <p className="text-gray-500 font-medium">No agreements found</p>
        <p className="text-gray-400 text-sm mt-1">
          Create an agreement to view rent data
        </p>
      </div>
    );
  }

  if (isLoading || data.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center w-full py-8">
        <Lottie
          animationData={loaderAnimation}
          loop={true}
          className="w-20 h-20"
        />
        <p className="text-gray-500 mt-2">Loading rent data...</p>
      </div>
    );
  }

  if (!currentMonthData) {
    return (
      <div className="flex flex-col items-center justify-center w-full py-8">
        <p className="text-gray-500">No rent data available</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center w-full">
      {/* Top Row: Navigation and Title */}
      <div className="flex justify-between items-center w-full mb-4 px-2">
        <button
          className={`text-sm font-medium ${
            chartCounter === data.length - 1
              ? "text-gray-400 cursor-not-allowed"
              : "text-blue-600 hover:text-blue-800"
          }`}
          onClick={handleOnPressNext}
          disabled={chartCounter === data.length - 1}
        >
          Prev
        </button>

        {/* 🔥 ENHANCED: Better title with navigation info */}
        <div className="text-center">
          <p className="text-base md:text-lg font-semibold text-gray-700">
            Monthly Rent{" "}
            {currentMonthData.short_title || currentMonthData.title}
          </p>
          {data.length > 1 && (
            <p className="text-xs text-gray-500">
              {chartCounter + 1} of {data.length}
            </p>
          )}
        </div>

        <button
          className={`text-sm font-medium ${
            chartCounter === 0
              ? "text-gray-400 cursor-not-allowed"
              : "text-blue-600 hover:text-blue-800"
          }`}
          onClick={handleOnPressPrev}
          disabled={chartCounter === 0}
        >
          Next
        </button>
      </div>

      {/* 🔥 ENHANCED: Better cards with trend indicators */}
      <div className="flex flex-wrap justify-center gap-3 md:gap-4 w-full">
        <RentCards
          label="Received"
          value={currentMonthData.received_rent}
          color="text-green-600"
        />

        <RentCards
          label="Due"
          value={currentMonthData.total_rent - currentMonthData.received_rent}
          color="text-red-600"
        />

        <RentCards
          label="Units Paid"
          value={currentMonthData.tenants_paid}
          color="text-blue-600"
        />

        <RentCards
          label="Units Due"
          value={currentMonthData.total_tenants - currentMonthData.tenants_paid}
          color="text-orange-600"
        />

        <RentCards
          label="Total"
          value={currentMonthData.total_rent}
          color="text-gray-800"
        />
      </div>

      {/* 🔥 NEW: Optional trend indicator */}
      {currentMonthData.is_trend_up !== undefined &&
        currentMonthData.percentage && (
          <div className="mt-4 text-center">
            <div
              className={`inline-flex items-center gap-1 px-3 py-1 rounded-full text-sm ${
                currentMonthData.is_trend_up
                  ? "bg-green-100 text-green-800"
                  : "bg-red-100 text-red-800"
              }`}
            >
              <span>{currentMonthData.is_trend_up ? "↗" : "↘"}</span>
              <span>{currentMonthData.percentage}% vs previous month</span>
            </div>
          </div>
        )}

      {/* 🔥 NEW: Quick refresh button (optional) */}
      <div className="mt-4">
        <button
          onClick={() => updateReportsData(Loading.MANUAL_REFRESHING)}
          disabled={isLoading}
          className="text-xs text-gray-500 hover:text-gray-700 disabled:opacity-50"
        >
          {isLoading ? "Refreshing..." : "Refresh Data"}
        </button>
      </div>
    </div>
  );
}
